<template>
    <div>
      <h3>Recent Tenant Statistics</h3>
      <a-skeleton
        active
        :loading="loading_stat"
        :title="false"
        :paragraph="{ rows: 8, width: 800 }"
      >
        <a-row :gutter="1" class="space-top1">
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic
                title="New User Registration"
                :value="allStatistics.new_registrations"
              >
                <template v-slot:suffix>
                  <a-icon type="flag" style="color:green;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic title="Successful User Logins" :value="allStatistics.successful_logins">
                <template v-slot:suffix>
                  <a-icon type="check-circle" style="color:green;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic title="Failed Login Attempts" :value="allStatistics.failed_logins">
                <template v-slot:suffix>
                  <a-icon type="stop" style="color:red;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic title="ID Tokens in Circulation" :value="allStatistics.valid_id_tokens">
                <template v-slot:suffix>
                  <a-icon type="idcard" style="color:green;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic
                title="Access Tokens in Circulation"
                :value="allStatistics.valid_access_tokens"
              >
                <template v-slot:suffix>
                  <a-icon type="profile" style="color:green;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic
                title="Refresh Tokens in Circulation"
                :value="allStatistics.valid_refresh_tokens"
              >
                <template v-slot:suffix>
                  <a-icon type="sync" style="color:green;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic
                title="Active Logged-in Sessions"
                :value="allStatistics.active_login_sessions"
              >
                <template v-slot:suffix>
                  <a-icon type="login" style="color:green;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card class="stats-card">
              <a-statistic title="Total Number of Users" :value="allStatistics.total_users_count">
                <template v-slot:suffix>
                  <a-icon type="user" style="color:blue;" />
                </template>
              </a-statistic>
            </a-card>
          </a-col>
        </a-row>
      </a-skeleton>
      <a-skeleton
        active
        :loading="loading_actv"
        :title="false"
        :paragraph="{ rows: 8, width: 800 }"
      >
        <a-row :gutter="8">
          <a-col :span="24">
            <a-card style="background: white;">
              <h3>Recent Activity Logs</h3>
              <a-list
                itemLayout="horizontal"
                :dataSource="allActivitiesData"
                bordered
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <a slot="title" class="logs">
                      <a-tag color="green">{{item._source.request_method}}</a-tag>
                      <a-tag color="blue">{{item._source.response_status_code}}</a-tag>
                      <a-tag color="pink">{{item._source['@timestamp']}}</a-tag>
                      <a-tag color="violet">{{item._source.remote_addr}}</a-tag>
                      <span>
                        path: {{item._source.request_path}}, user: {{item._source.user}},
                        request_id: {{item._source.request_id}}, agent: {{item._source.http_user_agent}}
                      </span>
                    </a>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-card>
          </a-col>
        </a-row>
      </a-skeleton>
    </div>

</template>
<script>
export default {
  name: "app",
  data() {
    return {
      pagination: {
        onChange: page => {
          console.log(page);
          this.paginater(page);
        },
        simple: true,
        total: 50,
        pageSize: 10
      },
      payload: this.$auth.session.id_payload,
      loading_stat: true,
      loading_actv: true,
      allActivitiesData: []
    };
  },

  methods: {
    async paginater(page) {
      try {
        await this.$store.dispatch("tenant/getItems", {
          endpoint: "activities",
          params: { page: page }
        });
        this.pagination.total = this.$store.state.tenant.activities_count;
        this.allActivitiesData = this.$store.state.tenant.activities;
        this.loading_actv = false;
      } catch (error) {
        console.error(error);
        this.loading_actv = false;
      }
    }
  },
  computed: {
    allStatistics() {
      return this.$store.state.tenant.statistics;
    },
  },

  beforeCreate: async function() {
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "statistics"
      });
      this.loading_stat = false;
    } catch (error) {
      console.error(error);
      this.loading_stat = false;
    }
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "activities"
      });
      this.pagination.total = this.$store.state.tenant.activities_count;
      this.allActivitiesData = this.$store.state.tenant.activities;
      this.loading_actv = false;
    } catch (error) {
      console.error(error);
      this.loading_actv = false;
    }
  }
};
</script>

<style>

</style>
